import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { ScrollManager } from "@/components/site/SectionLink";
import HomePage from "@/pages/HomePage";
import ServicePage from "@/pages/ServicePage";
import AreaPage from "@/pages/AreaPage";
import AreasHub from "@/pages/AreasHub";
import NotFound from "@/pages/NotFound";

function AppLayout() {
  return (
    <>
      <ScrollManager />
      <div className="min-h-screen bg-white font-body" data-testid="site-root">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<Navigate to="/#services" replace />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/areas" element={<AreasHub />} />
            <Route path="/areas/:slug" element={<AreaPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export { AppLayout };

export default App;
